var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.833c0-.466 0-.7-.09-.878a.833.833 0 0 0-.365-.364c-.178-.091-.412-.091-.878-.091H9.333c-.466 0-.7 0-.878.09a.833.833 0 0 0-.364.365C8 3.133 8 3.367 8 3.833v2.334c0 .466 0 .7-.09.878a.833.833 0 0 1-.365.364c-.178.091-.412.091-.878.091H4.333c-.466 0-.7 0-.878.09a.833.833 0 0 0-.364.365C3 8.133 3 8.367 3 8.833v2.334c0 .466 0 .7.09.878.08.157.208.284.365.364.178.091.412.091.878.091h2.334c.466 0 .7 0 .878.09.157.08.284.208.364.365.091.178.091.412.091.878v2.334c0 .466 0 .7.09.878.08.157.208.284.365.364.178.091.412.091.878.091h2.334c.466 0 .7 0 .878-.09a.833.833 0 0 0 .364-.365c.091-.178.091-.412.091-.878v-2.334c0-.466 0-.7.09-.878a.833.833 0 0 1 .365-.364c.178-.091.412-.091.878-.091h2.334c.466 0 .7 0 .878-.09a.833.833 0 0 0 .364-.365c.091-.178.091-.412.091-.878V8.833c0-.466 0-.7-.09-.878a.833.833 0 0 0-.365-.364c-.178-.091-.412-.091-.878-.091h-2.334c-.466 0-.7 0-.878-.09a.833.833 0 0 1-.364-.365C13 6.867 13 6.633 13 6.167V3.833z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalCross);
export default __webpack_public_path__ + "static/media/medicalCross.1257a337ba25bca2d3a4070040b560df.svg";
export { ForwardRef as ReactComponent };